import React from "react";

const WorkExperience = ({ experiences }) => {
  const defaultExperiences = [
    {
      company: "DBS Bank Ltd",
      position: "Software Developer Intern",
      duration: "May 2024 - August 2024",
      responsibilities: [
        "Developed a translation tool for Hong Kong translators which integrates Gen-AI capabilities and Retrieval Augmented Generation (RAG) techniques",
        "Completed various front end development tasks using React and Ant Design UI library.",
        "Wrote extensive test cases using React Testing Library and performed regression testing as well as User Acceptance Testing (UAT).",
      ],
    },
    {
      company: "FoodLine.sg Pte. Ltd.",
      position: "Full-Stack Software Developer Intern",
      duration: "August 2023 - December 2023",
      responsibilities: [
        "Engaged in full-stack web development, using PHP and JavaScript for server-side scripting. ",
        "Integrated Zoho CRM into the backend application, streamlining customer-facing processes and enhancing lead management.",
        "Designed meticulous database schemas in MySQL and integrated them into the backend application.",
      ],
    },
    {
      company: "Undercurrent Capital Pte. Ltd.",
      position: "Software Engineer Intern",
      duration: "May 2023 - August 2023",
      responsibilities: [
        "Implemented front-end interfaces for Decentralised Applications (DApps) using React and Tailwind CSS.",
        "Improved user experience by identifying bugs and refining application interface.",
        "Authored comprehensive test cases using Mocha Testing Framework.",
      ],
    },
  ];

  const workExperiences = experiences || defaultExperiences;

  return (
    <div id='workExperience' className='flex-col text-center'>
      <div className='text-5xl font-bold py-8' data-aos={"slide-down"}>
        Work Experience
      </div>
      <div className='flex-col text-center'>
        <ol className='relative ml-9 mb-6'>
          {workExperiences.map((experience, index) => (
            <li key={index} className='mb-10' data-aos='zoom-in'>
              <h3 className='mb-1 text-lg font-bold text-white'>
                {experience.position}
              </h3>
              <h4 className='mb-1 text-lg text-white'>{experience.company}</h4>
              <time className='block pt-1 pb-3 text-sm font-normal leading-none text-gray-500'>
                {experience.duration}
              </time>
              <ul>
                {experience.responsibilities.map((responsibility, idx) => (
                  <li
                    key={idx}
                    className='mb-2 text-base font-normal text-gray-400'
                  >
                    • {responsibility}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default WorkExperience;
